module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/advocate-payment/adv-pay-grid/adv-pay-grid.component.css
// module id = ./src/app/legal/advocate-payment/adv-pay-grid/adv-pay-grid.component.css
// module chunks = main